import { withConfiguration } from "./config";
import { token } from "./auth";

export const apiFetcher = (url) =>
  fetch(url, { method: "GET" })
    .then((result) => {
      const json = result.json();
      if (result.ok === false) {
        return json.then(Promise.reject.bind(Promise));
      } else {
        return json;
      }
    })
    .catch((e) => "error");

export const fetcher = (root, verb) => (url, payload, lang = "fr") => {
  return withConfiguration((config) => {
    return fetch(`${config[root]}${url}`, {
      method: verb,
      headers: new Headers({
        "Content-Type": "application/json;charset=UTF-8",
        authorization: token(),
        "Accept-Language": lang,
      }),
      body: payload !== undefined ? JSON.stringify(payload) : undefined,
    }).then((result) => {
      const json = result.json();
      if (result.ok === false) {
        return json.then(Promise.reject.bind(Promise));
      } else {
        return json;
      }
    });
  });
};

export const fileFetcher = (root, verb) => (url, data) => {
  return withConfiguration((config) => {
    return fetch(`${config[root]}${url}`, {
      method: verb,
      headers: new Headers({ authorization: token() }),
      body: data,
    }).then((result) => {
      const json = result.json();
      if (result.ok === false) {
        return json.then(Promise.reject.bind(Promise));
      } else {
        return json;
      }
    });
  });
};

export const postFile = fileFetcher("server", "POST");
export const getFile = (uri) =>
  withConfiguration((config) => `${config["imgServer"]}${uri}`);

export const post = fetcher("server", "POST");
export const put = fetcher("server", "PUT");
export const deleteHttp = fetcher("server", "DELETE");



// WEBPACK FOOTER //
// ./src/services/fetcher.js